import React, { useRef, useState, useEffect } from 'react';
import './contactUs.css';
import TextField from '@mui/material/TextField';
import Footer from '../shared/footer/footer';
import location from '../../assets/images/location.svg';
import phone from '../../assets/images/phone.svg';
import mail from '../../assets/images/mail.svg';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import useMediaQuery from '@mui/material/useMediaQuery';
import Header from '../shared/header/header';
import CircularProgress from "@mui/material/CircularProgress";
import Popup from "../shared/confirmPopup/Popup";
import { FormHelperText } from '@mui/material';
import { useSelector } from 'react-redux';
import useGetdata from '../../Hooks/useGetData';
import SnackbarNav from '../main/SnackbarNav/SnackbarNav';
import useIsMobile from '../../Hooks/useIsMobile';
import MobileMenu from '../main/SnackbarNav/MobileMenu';

const Home = () => {
  const sectionRef = useRef(null);

  const [age, setAge] = React.useState('');

  // const handleChange = (event) => {
  //   setAge(event.target.value);
  // };
  const isSmallScreen = useMediaQuery('(max-width:480px)');

  const baseURL = process.env.REACT_APP_BASE_URL;

  const [showModal, setShowModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    Name: "",
    LastName: "",
    Company: "",
    Email: "",
    Phone: "",
    Message: "",
    Enquiry: "",
  });

  const handleOpen = () => setShowModal(true);

  const handleClose = () => {
    setShowModal(false);
    setFormData({
      Name: "",
      LastName: "",
      Company: "",
      Email: "",
      Phone: "",
      Message: "",
      Enquiry: "",
    });
    setErrors({});
  };

  const handlesuccess = () => setShowSuccessModal(!showSuccessModal);

  useGetdata();
  const [enquiryDropdown, setEnquiryDropdown] = useState([]);
  const [footerData, setFooterData] = useState({});
  const data = useSelector((store) => store.data.HomeData);

  useEffect(() => {
    data?.items.forEach((ele) => {
      if (ele.Section == "GeneralQuery") {
        setEnquiryDropdown(ele.Queries);
      }
      if (ele.Section == "Footer") {
        setFooterData(ele);
      }
    });
  }, [data]);

  const validate = () => {
    const newErrors = {};
    if (!formData.Name.trim()) {
        newErrors.Name = "First name is required";
    } else if (!/^[A-Za-z\s]+$/.test(formData.Name)) {
        newErrors.Name = "First name must contain only letters";
    }
    if (!formData.LastName.trim()) {
        newErrors.LastName = "Last name is required";
    } else if (!/^[A-Za-z\s]+$/.test(formData.LastName)) {
        newErrors.LastName = "Last name must contain only letters";
    }
    if (!formData.Email.trim()) {
        newErrors.Email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.Email)) {
        newErrors.Email = "Email is invalid";
    }
    if (!formData.Phone.trim()) {
        newErrors.Phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.Phone)) {
        newErrors.Phone = "Phone number must be 10 digits";
    }
    if (!formData.Message.trim()) {
        newErrors.Message = "Message is required";
    }
    return newErrors;
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    const error = validateField(name, value);
      setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: error,
    }));
  };

  const validateField = (name, value) => {
    switch (name) {
        case "Name":
            if (!value.trim()) return "First name is required";
            if (!/^[A-Za-z\s]+$/.test(value)) return "First name must contain only letters";
            break;
        case "LastName":
            if (!value.trim()) return "Last name is required";
            if (!/^[A-Za-z\s]+$/.test(value)) return "Last name must contain only letters";
            break;
        case "Email":
            if (!value.trim()) return "Email is required";
            if (!/\S+@\S+\.\S+/.test(value)) return "Email is invalid";
            break;
        case "Phone":
            if (!value.trim()) return "Phone number is required";
            if (!/^\d{10}$/.test(value)) return "Phone number must be 10 digits";
            break;
        case "Message":
            if (!value.trim()) return "Message is required";
            break;
        default:
            return null;
    }
    return null; 
};

  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    setIsSubmitting(true);
    const formDataJSON = JSON.stringify(formData);
    try {
      const response = await fetch(
        `${baseURL}/main-website/post-contact-form`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: formDataJSON,
        }
      );

      if (response.ok) {
        handleClose();
        handlesuccess();
      } else {
        alert("Failed to submit the form.");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const isMobile = useIsMobile();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="contact-us-page-wrapper">
      <div >
        <div ref={sectionRef} className="contact-container">
          <div className="media-home-container">
            {/* <div className="home-header">
              <Link to="/home" className="p-left"><img  src={skyeairLogo} alt="Not Found" /></Link>
              <div className="about-us p-right" onClick={handleOpen}>
                <img src={homeIcon} alt="Icon" height={22} />
                <span > Deliver With Us Today</span>
              </div>
            </div> */}
            <Header />
            {/* <img className="main-bg-img" src={img1} width={'100%'} alt="Not Found" /> */}
          </div>
        </div>
        <div className="contact-section-container">

          <div className="row container-fluid align-items-center">
            <div className="col-md-5">
              <div className="contact-detail-info">
                <h2 className="mb-4 contact-heading capitalize-first-letter">Contact our support team</h2>
                <p className="font-light">Get in touch with our dedicated support team for prompt assistance. We are here to address your inquiries and provide the help you need</p>
                <div className="contact-details-section contact-info font-light">
                  <div class="d-flex ">
                    <img src={location} height={17} className="me-2 mt-1" /><p> {footerData?.Content?.OfficeAddress ? footerData?.Content.OfficeAddress : 'Skye Air Mobility, 272, 8th Floor,Incuspaze M3M Urbana Premium,Golf Course Extension Road, Sector 67, Gurugram, Haryana 122101'} </p>
                  </div>
                  <div class="d-flex ">
                    <img src={mail} height={10} className="me-2 mt-2" /> <p> {footerData?.Content?.OfficeEmail ? footerData?.Content.OfficeEmail : 'info@skyeair.tech'}</p>
                  </div>
                  <div class="d-flex ">
                    {/* <img src={phone} height={15} className="me-2 mt-1" /> <p> +123-456-7890</p> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-7">
              <div className="contact-form">
                <h2 className="fw-bold capitalize-first-letter">Hello! <br></br> We'd be happy to hear from you.</h2>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3  mt-3">
                      <TextField
                        name="Name"
                        label={
                            <>
                              First Name <span style={{ color: 'red' }}>*</span>
                            </>
                        }
                        fullWidth
                        value={formData.Name}
                        onChange={handleChange}
                        error={!!errors.Name}
                        helperText={errors.Name}
                        size={isSmallScreen ? 'medium' : 'small'}
                      />
                    </div>
                    <div className="col-md-6 mb-3  mt-3">
                      <TextField
                        name="LastName"
                        label={
                          <>
                            Last Name <span style={{ color: 'red' }}>*</span>
                          </>
                      }
                        fullWidth
                        value={formData.LastName}
                        onChange={handleChange}
                        error={!!errors.LastName}
                        helperText={errors.LastName}
                        size={isSmallScreen ? 'medium' : 'small'}
                      />
                    </div>
                  </div>

                  {/* <div className="row">
                    <div className="col-md-6 mb-3  mt-3">
                      <TextField
                        name="Company"
                        label="Organization"
                        fullWidth
                        value={formData.Company}
                        onChange={handleChange}
                        size={isSmallScreen ? 'medium' : 'small'}
                      />
                    </div>
                    <div className="col-md-6 mb-3  mt-3 custom-select-label">
                      <FormControl fullWidth error={!!errors.Enquiry}>
                        <InputLabel id="general-enquiry">Select Enquiry Type</InputLabel>
                        <Select
                          labelId="general-enquiry"
                          name="Enquiry"
                          value={formData.Enquiry}
                          onChange={handleChange}
                          label="Select Enquiry Type"
                          size={isSmallScreen ? 'medium' : 'small'}
                        >
                        {enquiryDropdown &&
                          enquiryDropdown?.map((option, index) => (
                            <MenuItem key={index} value={option}>
                              {option}
                            </MenuItem>
                          ))
                        }
                        </Select>
                        <FormHelperText>{errors.Enquiry}</FormHelperText>
                      </FormControl>
                    </div>
                  </div> */}


                  <div className="row">
                    <div className="col-md-6 mb-3  mt-3">
                      <TextField
                        name="Email"
                        label={
                          <>
                           Email ID <span style={{ color: 'red' }}>*</span>
                          </>
                      }
                        fullWidth
                        value={formData.Email}
                        onChange={handleChange}
                        error={!!errors.Email}
                        helperText={errors.Email}
                        size={isSmallScreen ? 'medium' : 'small'}
                      />
                    </div>
                    <div className="col-md-6 mb-3  mt-3">
                      <TextField
                        name="Phone"
                        label={
                          <>
                            Phone Number <span style={{ color: 'red' }}>*</span>
                          </>
                        }
                        fullWidth
                        value={formData.Phone}
                        onChange={handleChange}
                        error={!!errors.Phone}
                        helperText={errors.Phone}
                        size={isSmallScreen ? 'medium' : 'small'}
                        inputProps={{ maxLength: 10 }}
                      />
                    </div>
                  </div>

                  <div className="mb-3  mt-3">
                    {/* <label htmlFor="help" className="form-label">How can we help?</label><br></br> */}
                    <TextField
                     label={
                      <>
                       Message <span style={{ color: 'red' }}>*</span>
                      </>
                    }
                      multiline
                      maxRows={4}
                      fullWidth
                      value={formData.Message}
                      onChange={handleChange}
                      name="Message"
                      error={!!errors.Message}
                      helperText={errors.Message}
                      minRows={6}  
                    />
                  </div>

                  <button className="w-100 btn btn-primary py-2 mt-3 contact-submit" disabled={isSubmitting}>
                    {isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Submit"}
                  </button>
                </form>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className="map-section">
        <section id="location-map">
          <h1 className="text-center fw-bold pt-5 pb-3">Our Headquarter</h1>
          <div style={{ width: '100%', height: '80vh' }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4321.1718830113305!2d77.0638756824029!3d28.39262610783731!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d23d02b8eabc9%3A0xea3571781e6cdb8b!2sIncuspaze%20M3M%20Urbana%20Premium!5e0!3m2!1sen!2sin!4v1772796718843!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </section>
      </div>
      <Footer />

      {showSuccessModal && <Popup onClose={handlesuccess} />}

    <section>
        {!isMobile && <SnackbarNav />}
        {isMobile && !menuOpen && (
          <button className="menu-toggle" onClick={() => setMenuOpen(true)}>
            ☰
          </button>
        )}
          {isMobile && menuOpen && (
          <MobileMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
        )}
        </section>
    </div>


  );
};
export default Home;
